"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AddEmployee;
var _react = _interopRequireWildcard(require("react"));
require("./userIndex.css");
var _Services = require("../../common_features/utility/Services");
var _reactRouterDom = require("react-router-dom");
var _helper = require("../../common_features/utility/helper");
var _AddEmployeeComponent = _interopRequireDefault(require("../../components/UserDashboard/AddEmployeeComponent"));
var _RoutePath = _interopRequireDefault(require("../../RoutePath"));
var _reactRedux = require("react-redux");
var _images = require("../../common_features/assets/images");
var _loginReducer = require("../../common_features/redux/reducers/loginReducer");
var _ToastContainer = require("@ccw-pwa-ui/ToastContainer");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function AddEmployee(props) {
  var _userDetails$ServiceP;
  const baseFilter = {
    title: /*#__PURE__*/_react.default.createElement("span", {
      style: {
        textTransform: 'capitalize'
      },
      "data-testid": "all",
      "data-value": "Select"
    }, "Select"),
    key: 'title',
    value: 'Select'
  };
  const pageSize = 25;
  let digitRegex = /^\d+$/;
  const {
    userInfo,
    userRoles
  } = (0, _reactRedux.useSelector)(state => state.login);
  const {
    data: userDetails
  } = (0, _reactRedux.useSelector)(state => state.userDetails);
  const {
    userDataForEdit
  } = (0, _reactRedux.useSelector)(state => state.users);
  const {
    stores
  } = (0, _reactRedux.useSelector)(state => state.stores);
  const errorList = {
    fName: "",
    lName: "",
    email: "",
    conEmail: "",
    conEmailCheck: ""
  };
  const errorValidList = {
    fNameValid: null,
    lNameValid: null,
    emailValid: null,
    conEmailValid: null
  };
  const navigate = (0, _reactRouterDom.useNavigate)();
  const dispatch = (0, _reactRedux.useDispatch)();
  const [editView, setEditView] = (0, _react.useState)(false);
  const [editEmail, setEditEmail] = (0, _react.useState)(false);
  const [isLoading, setIsLoading] = (0, _react.useState)(false);
  const [fName, setFName] = (0, _react.useState)('');
  const [lName, setLName] = (0, _react.useState)('');
  const [email, setEmail] = (0, _react.useState)('');
  const [conEmail, setConEmail] = (0, _react.useState)('');
  const [errorMessage, setErrorMessage] = (0, _react.useState)(errorList);
  const [formErrorList, setFormErrorList] = (0, _react.useState)(errorValidList);
  const [conEmailCheck, setconEmailCheck] = (0, _react.useState)(false);
  const [errorModal, setErrorModal] = (0, _react.useState)(false);
  const [enableStoreComponenet, setEnableStoreComponent] = (0, _react.useState)(false);
  const [count, setCount] = (0, _react.useState)(0);
  const [currentFilter, setCurrentFilter] = (0, _react.useState)(baseFilter);
  const [bodySchema, setBodySchema] = (0, _react.useState)([]);
  const {
    countriesList
  } = (0, _reactRedux.useSelector)(state => state.countries);
  const [rowSelect, setRowSelect] = (0, _react.useState)([]);
  const [allSelect, setAllSelect] = (0, _react.useState)(false);
  const [storesToBeAssigned, setStoresToBeAssigned] = (0, _react.useState)([]);
  const [currentPage, setCurrentPage] = (0, _react.useState)(1);
  const [query, setQuery] = (0, _react.useState)('');
  const [searchDisabled, setSearcDisabled] = (0, _react.useState)(true);
  const [isTaggingFailed, setIsTaggingFailed] = (0, _react.useState)(false);
  const [characterLimitPopUp, setCharacterLimitPopUp] = (0, _react.useState)(false);
  const [zipCodeLengthValidation, setZipCodeLengthValidation] = (0, _react.useState)(false);
  const [isDataLoading, setIsDataLoading] = (0, _react.useState)(false);
  const [storeTagBtnDisable, setStoreTagBtnDisable] = (0, _react.useState)(false);
  const [searchReset, setSearchReset] = (0, _react.useState)(1);
  const [successModalContent, setSuccessModalContent] = (0, _react.useState)({
    modalHeaderText: "",
    modalDetailText: "",
    modalSecondDetailText: ""
  });
  const [errorModalData, setErrorModalData] = (0, _react.useState)({
    ErrorModalHeaderText: "This ".concat(userInfo.userType === 4 ? "Employee" : "Technician", " has already accepted invitation"),
    ErrorModalDetailText: "Active and In Process ".concat(userInfo.userType === 4 ? "Employees" : "Technicians", " will not receive an invitation")
  });
  const [modalShow, setModalShow] = (0, _react.useState)(false);
  const [modalContent, setModalContent] = (0, _react.useState)({
    headerContent: "",
    detailContent: ""
  });
  const successData = {
    variant: "resend-invitation",
    displayCrossIcon: false,
    modalHeaderText: userDataForEdit.editView ? modalContent.headerContent : successModalContent.modalHeaderText,
    modalHeaderTextStyle: {
      fontSize: 20,
      color: '#333333',
      fontWeight: 600,
      lineHeight: "27px",
      fontFamily: "Poppins",
      marginTop: 18
    },
    modalDetailText: userDataForEdit.editView ? modalContent.detailContent : successModalContent.modalDetailText,
    modalDetailText2Style: {
      fontSize: 16,
      color: '#333333',
      fontWeight: 400,
      lineHeight: "22px",
      fontFamily: "Poppins",
      width: 337,
      textAlign: 'left'
    },
    modalSecondDetailText: successModalContent.modalSecondDetailText,
    modalDetailTextStyle: {
      fontSize: 16,
      color: '#333333',
      fontWeight: 400,
      lineHeight: "22px",
      fontFamily: "Poppins",
      marginTop: 4
    },
    positiveActionButtonTitle: userDataForEdit.editView ? "Done" : "Continue",
    negativeButtonActionTitle: null,
    positiveAction: () => {
      setModalShow(false);
      handlePositiveAction();
    }
    // crossIconAction: () => { setShowModal(false) }
  };
  const handlePositiveAction = () => {
    if (isTaggingFailed) {
      dispatch((0, _loginReducer.setSideMenuState)('2'));
      navigate(_RoutePath.default.manageStore.useLink);
    } else {
      handleBackButton();
    }
  };
  const filterDropDownList = [{
    "name": "Store Name"
  }, {
    "address": "Address"
  }, {
    "address": "Zip Code"
  }];
  const dataTableHeaderSchema = [{
    "name": "Store Name"
  }, {
    "address": "Address"
  }];
  const filterDropDown = [{
    title: 'Select',
    key: 'all',
    value: "Select"
  }, ...filterDropDownList].map(item => {
    return {
      title: /*#__PURE__*/_react.default.createElement("span", {
        style: {
          textTransform: 'capitalize'
        },
        "data-testid": Object.values(item)[0],
        "data-value": Object.keys(item)[0]
      }, Object.values(item)[0]),
      key: Object.keys(item)[0],
      value: Object.values(item)[0]
    };
  });
  const fetchStores = async pageNo => {
    setIsDataLoading(true);
    let params = {
      entity: "stores",
      limit: pageSize,
      pageNo: pageNo || currentPage
    };
    if (currentFilter.key !== "title") {
      params = {
        ...params,
        attribute: currentFilter.key,
        query: query
      };
    }
    await (0, _Services.searchStore)(params).then(data => {
      if (data.data.rows.length) {
        const rowBody = data.data.rows.map(row => {
          const address = (0, _helper.isJSON)(row.address) ? (0, _helper.bindAddress)(JSON.parse(row.address), countriesList) : row.address;
          return {
            id: row.storeId,
            name: row.name,
            address: address,
            isActive: 'Active'
          };
        });
        setCount(Number(data.data.count));
        setBodySchema(rowBody);
        setIsLoading(false);
        setIsDataLoading(false);
      } else {
        setBodySchema([]);
        setIsLoading(false);
        setIsDataLoading(false);
      }
    }).catch(() => {
      setIsLoading(false);
      setIsDataLoading(false);
    });
  };
  const setRowSelected = rowId => {
    if (allSelect) {
      setAllSelect(false);
      setRowSelect([rowId]);
      return;
    }
    const resultArr = rowSelect.filter(arrObj => arrObj !== rowId);
    if (resultArr.length === (rowSelect === null || rowSelect === void 0 ? void 0 : rowSelect.length)) resultArr.push(rowId);
    setRowSelect(resultArr);
  };
  const setAllSelected = flag => {
    setAllSelect(flag);
    setRowSelect([]);
    if (flag) {
      let data = bodySchema.map(rowData => rowData.id);
      setRowSelect(data);
    } else {
      setRowSelect([]);
    }
  };
  const openStoreSubComponent = () => {
    setRowSelect([...storesToBeAssigned]);
    setEnableStoreComponent(true);
  };
  const handleStoreModalSubmit = () => {
    setStoresToBeAssigned([...rowSelect]);
    setEnableStoreComponent(false);
    setQuery('');
    setCurrentFilter(baseFilter);
    setSearchReset(pre => pre + 1);
  };
  const handleStoreModalCancel = () => {
    setQuery('');
    setEnableStoreComponent(false);
    setRowSelect([]);
    setAllSelect(false);
    setCurrentFilter(baseFilter);
    setSearchReset(pre => pre + 1);
  };
  const handleOnKeyPress = e => {
    if (e.key === "Enter" && currentFilter.value === "Zip Code" && (query.length !== 5 || !digitRegex.test(query))) {
      setZipCodeLengthValidation(true);
    } else {
      if (e.key === "Enter" && (query.length >= 3 || query === '')) {
        setCharacterLimitPopUp(false);
        fetchStores();
      } else {
        setCharacterLimitPopUp(true);
      }
    }
  };
  const checkClearBtnListener = () => {
    setCharacterLimitPopUp(false);
    setZipCodeLengthValidation(false);
    if (document.querySelector('.modal-with-table-addUser .ant-input-clear-icon-has-suffix')) {
      document.querySelector('.modal-with-table-addUser .ant-input-clear-icon-has-suffix').onclick = () => {
        setQuery('');
        setCurrentPage(1);
      };
    }
  };
  const handlePageChange = pageNum => {
    setQuery('');
    setRowSelect([]);
    setAllSelect(false);
    setCurrentPage(pageNum);
    fetchStores(pageNum);
  };
  const initiateSearch = () => {
    if (currentFilter.value === "Zip Code" && (query.length !== 5 || !digitRegex.test(query))) {
      setZipCodeLengthValidation(true);
    } else {
      if (query.length <= 3 && query !== '') {
        setCharacterLimitPopUp(true);
      } else {
        setCharacterLimitPopUp(false);
        fetchStores(1);
      }
    }
  };
  (0, _react.useEffect)(() => {
    if (currentFilter.key !== "title") {
      setSearcDisabled(false);
    } else {
      setSearcDisabled(true);
    }
    setQuery('');
    setCharacterLimitPopUp(false);
    setZipCodeLengthValidation(false);
  }, [currentFilter]);
  /* On Basis of Value Receieved from Reducer It will enable the edit View */
  (0, _react.useEffect)(() => {
    if (userDataForEdit.editView) {
      setEditView(true);
      setFName(userDataForEdit.firstName);
      setLName(userDataForEdit.lastName);
      setEmail(userDataForEdit.email);
      setConEmail(userDataForEdit.email);
    }
  }, [userDataForEdit]);
  (0, _react.useEffect)(() => {
    if (conEmail) {
      if ((email === null || email === void 0 ? void 0 : email.toLowerCase()) === (conEmail === null || conEmail === void 0 ? void 0 : conEmail.toLowerCase())) {
        setconEmailCheck(true);
      } else {
        setconEmailCheck(false);
      }
    }
  }, [email, conEmail]);
  (0, _react.useEffect)(() => {
    if (userDataForEdit.email !== email) {
      setModalContent({
        headerContent: "Email Updated",
        detailContent: "Verification mail has been sent to the user which will be valid for the next 24 hours. You can check the status."
      });
    } else if (userDataForEdit.lName !== lName || userDataForEdit.fName !== fName) {
      setModalContent({
        headerContent: "Details Updated",
        detailContent: "".concat(userInfo.userType === 4 ? "Employee" : "Technician", " Details Updated Successfully.")
      });
    }
  }, [email, fName, lName]);
  const handleInputChange = (e, fieldName) => {
    let {
      value
    } = e.target;
    let getErrorMessages = errorMessage;
    let getFormErrorList = formErrorList;
    switch (fieldName) {
      case 'email':
        setEmail(value);
        let emailValid = false;
        emailValid = value.trim().length > 0 && (0, _helper.validateEmail)(value);
        getErrorMessages.email = emailValid ? '' : "Please enter valid email address";
        if (emailValid) {
          if (conEmail && value != conEmail) {
            getErrorMessages.conEmail = "Email address not matched";
            getFormErrorList.conEmailValid = true;
          } else {
            conEmail ? delete getFormErrorList.conEmailValid : getFormErrorList.conEmailValid = true;
          }
          delete getFormErrorList.emailValid;
        } else {
          getFormErrorList.emailValid = true;
        }
        break;
      case 'conEmail':
        setConEmail(value);
        let conEmailValid = false;
        conEmailValid = value.trim().length > 0 && (0, _helper.validateEmail)(value);
        getErrorMessages.conEmail = conEmailValid ? '' : "Please enter valid email address";
        if (conEmailValid) {
          var _String;
          if (((_String = String(value)) === null || _String === void 0 ? void 0 : _String.toLowerCase()) != (email === null || email === void 0 ? void 0 : email.toLowerCase())) {
            getErrorMessages.conEmail = "Confirm email does not match";
            getFormErrorList.conEmailValid = true;
          } else {
            delete getFormErrorList.conEmailValid;
          }
        } else {
          getFormErrorList.conEmailValid = true;
        }
        break;
      case 'fName':
        setFName(value);
        let fNameValid = value.trim().length > 0;
        getErrorMessages.fName = fNameValid ? '' : "Enter valid first name";
        if (fNameValid) {
          delete getFormErrorList.fNameValid;
        } else {
          getFormErrorList.fNameValid = true;
        }
        break;
      case 'lName':
        setLName(value);
        let lNameValid = value.trim().length > 0;
        getErrorMessages.lName = lNameValid ? '' : "Enter valid last name";
        if (lNameValid) {
          delete getFormErrorList.lNameValid;
        } else {
          getFormErrorList.lNameValid = true;
        }
        break;
    }
  };
  const getCurrentRole = () => {
    (0, _Services.getRoles)().then(async res => {
      if (res.success) {
        let resData = await (res === null || res === void 0 ? void 0 : res.data);
        dispatch((0, _loginReducer.SetUserRoles)(resData));
      }
    });
  };
  (0, _react.useEffect)(() => {
    getCurrentRole();
  }, []);
  (0, _react.useEffect)(() => {
    fetchStores(1);
    if (stores.length) {
      setStoreTagBtnDisable(false);
    } else {
      setStoreTagBtnDisable(true);
    }
  }, [searchReset]);
  (0, _react.useEffect)(() => {
    if (query === "") fetchStores(1);
    return () => {};
  }, [query]);
  const handleSubmit = async () => {
    const userRoleID = userRoles.filter(role => role.userType === userInfo.serachUserType);
    if (userRoleID.length > 0) {
      let empData = {
        email: email.toLowerCase(),
        fName: fName,
        lName: lName,
        roleId: userRoleID[0].roleId,
        orgID: userInfo.orgID
      };
      setIsLoading(true);
      await (0, _Services.inviteEmployee)(empData).then(async apiResp => {
        if (apiResp && apiResp !== null && apiResp !== void 0 && apiResp.success) {
          if (storesToBeAssigned.length) {
            const requestType = userInfo.userType === 4 ? "TagManager" : "TagTechnician";
            await (0, _Services.TagTechnicianToStore)({
              storeIds: [...storesToBeAssigned],
              userId: [apiResp.data.id],
              requestType
            }).then(taggingResp => {
              if (taggingResp.success) {
                setIsTaggingFailed(false);
                setSuccessModalContent({
                  modalHeaderText: "Invitation Sent",
                  modalDetailText: "Your invitation has been successfully sent."
                });
                setModalShow(true);
              } else {
                setIsTaggingFailed(true);
                setSuccessModalContent({
                  modalHeaderText: "Invitation Sent",
                  modalDetailText: "Your invitation has been successfully sent.",
                  modalSecondDetailText: "Store(s) could not be assigned. Click on continue to assign."
                });
                setModalShow(true);
              }
            }).catch(e => {
              _ToastContainer.CustomToast.error((e === null || e === void 0 ? void 0 : e.message) || "Something went wrong");
            });
          } else {
            setIsTaggingFailed(false);
            setSuccessModalContent({
              modalHeaderText: "Invitation Sent",
              modalDetailText: "Your invitation has been successfully sent."
            });
            setModalShow(true);
          }
        } else {
          _ToastContainer.CustomToast.error(apiResp.message || "Something went wrong");
        }
        setIsLoading(false);
      }).catch(error => {
        var _error$response;
        if (((_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.data.error.code) === "UsernameExistsException") {
          if ([2, 3].includes(error.response.data.data.invitationStatus)) {
            setErrorModalData({
              ErrorModalHeaderText: "This ".concat(userInfo.userType === 4 ? "Employee" : "Technician", " has already been added."),
              ErrorModalDetailText: "Use Resend Invitiation tool if you wish to send another email."
            });
          } else {
            setErrorModalData({
              ErrorModalHeaderText: "This ".concat(userInfo.userType === 4 ? "Employee" : "Technician", " has already accepted invitation"),
              ErrorModalDetailText: "Active and In Process ".concat(userInfo.userType === 4 ? "Employees" : "Technicians", " will not receive an invitation")
            });
          }
          setErrorModal(true);
        }
        setIsLoading(false);
      });
    }
  };
  function resetForm() {
    setFName('');
    setLName('');
    setEmail('');
    setConEmail('');
    setErrorMessage(errorList);
    setFormErrorList(errorValidList);
  }
  function handleBackButton() {
    resetForm();
    navigate(_RoutePath.default.userManage.useLink);
  }
  function handleErrorModel(mode) {
    setErrorModal(false);
  }

  /* After Entering the edit View Click on BTN to run this function & start edit View*/
  const handleEditBtn = async () => {
    setEditEmail(true);
    setErrorMessage({});
    setFormErrorList({});
    return true;
  };

  /*When click on submit after email update this function will be called and API Call */
  const updateHandle = async () => {
    setIsLoading(true);
    await (0, _Services.commonUpdateUser)(userDataForEdit.userType, userDataForEdit.id, email, fName, lName, userDataForEdit.phone).then(apiResp => {
      if (apiResp && apiResp.success) {
        setModalShow(true);
      } else {
        throw apiResp;
      }
      setIsLoading(false);
    }).catch(error => {
      var _error$response2, _error$response2$data;
      setErrorModalData({
        ErrorModalHeaderText: error.message,
        ErrorModalDetailText: error === null || error === void 0 ? void 0 : (_error$response2 = error.response) === null || _error$response2 === void 0 ? void 0 : (_error$response2$data = _error$response2.data) === null || _error$response2$data === void 0 ? void 0 : _error$response2$data.message
      });
      setErrorModal(true);
    });
    setIsLoading(false);
    return true;
  };
  const isFieldsUpdated = () => {
    if (userDataForEdit.email === email && userDataForEdit.firstName === fName && userDataForEdit.lastName === lName) {
      return true;
    } else {
      return false;
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "enter-email-main-container"
  }, /*#__PURE__*/_react.default.createElement(_AddEmployeeComponent.default, {
    isLoading: isLoading,
    handleBackButton: handleBackButton,
    headerTextLinkTitle: "Manage ".concat(userInfo.userType === 4 ? "Employee" : "Technician"),
    headerTextPageLinkIcon: ">",
    headerTextPageLinkText: "".concat(editView ? editView && !editEmail ? "View" : "Edit" : "Add", " ").concat(userInfo.userType === 4 ? "Employee" : "Technician"),
    headerTextDescOne: "We will send an invitation to this ".concat(userInfo.userType === 4 ? "Employee" : "Technician", " to join your Pentair ServiceConnect app account. Invitation is valid only for 24 hours."),
    headerTextDescTwo: "By sending this invitation, you are agreeing to provide full app access to this ".concat(userInfo.userType === 4 ? "Employee" : "Technician", ", including customer information. It is your responsibility to make sure this ").concat(userInfo.userType === 4 ? "Employee" : "Technician", " handles such information appropriately. ").concat(userInfo.userType === 4 ? "Employees" : "Technicians", " can be added or removed from your account by visiting \u201CManage ").concat(userInfo.userType === 4 ? "Employees" : "Technicians", "\u201D."),
    headerTextPageTitle: "".concat(editView ? editView && !editEmail ? "View" : "Edit" : "Add", " ").concat(userInfo.userType === 4 ? "Employee" : "Technician"),
    formErrorList: formErrorList,
    errorMessage: errorMessage,
    handleInputChange: handleInputChange,
    headerTextFName: "First Name",
    headerTextFNamePlaceHolder: "Enter first name",
    fName: fName,
    headerTextLName: "Last Name",
    headerTextLNamePlaceHolder: "Enter last name",
    lName: lName,
    headerTextEmail: "".concat(userInfo.userType === 4 ? "Employee" : "Technician", " Email"),
    headerTextEmailPlaceHolder: "Enter email address",
    email: email,
    headerTextConEmail: "Confirm Email",
    headerTextConEmailPlaceHolder: "Enter confirm email address",
    conEmail: conEmail,
    conEmailCheck: conEmailCheck,
    handleSubmit: handleSubmit,
    errorModal: errorModal,
    inviteModalVarient: "resend-invitation",
    modalHeaderText: /*#__PURE__*/_react.default.createElement("span", null, "Are you sure you want to ", /*#__PURE__*/_react.default.createElement("br", null), "resend invitation the ", userInfo.userType === 4 ? "Employee" : "Technician", "(s)?\""),
    modalDetailText: "Active or In Process ".concat(userInfo.userType === 4 ? "Employees" : "Technicians", " will not receive an invitation"),
    reInviteModal: true,
    positiveActionButtonTitle: "Send Invitations",
    negativeButtonActionTitle: "Cancel",
    handleErrorModal: () => handleErrorModel(false),
    customIcon: /*#__PURE__*/_react.default.createElement("img", {
      src: _images.warningSvg.default
    }),
    ErrorModalVariant: "remove-user-modal",
    ErrorModalHeaderText: errorModalData.ErrorModalHeaderText,
    ErrorModalDetailText: errorModalData.ErrorModalDetailText,
    ErrorModalDetailText2: "",
    positiveActionErrorButtonTitle: "Continue",
    successModalData: successData,
    modalShow: modalShow
    /**
     * All The props below are used to segregate the Add employee &
     * Edit Email View for a User.
     */,
    editViewEnable: editView,
    userDataForEdit: userDataForEdit,
    editText: "Edit ".concat(userInfo.userType === 4 ? "Employee" : "Technician"),
    editImage: _images.EditPencil.default,
    handleEditBtn: handleEditBtn,
    emailEdit: editEmail,
    oldEmail: isFieldsUpdated(),
    updateHandleFunc: updateHandle,
    selectStoreBtn: true,
    selectedStoresCount: storesToBeAssigned.length,
    setEnableStoreComponentProp: openStoreSubComponent,
    enableStoreComponentProp: enableStoreComponenet,
    userType: userInfo.userType,
    filterDropDown: filterDropDown,
    setCurrentFilter: setCurrentFilter,
    currentFilter: currentFilter,
    headerSchema: dataTableHeaderSchema,
    bodySchema: bodySchema,
    rowSelect: rowSelect,
    allSelect: allSelect,
    setRowSelected: setRowSelected,
    setAllSelected: setAllSelected,
    searchDisabled: searchDisabled,
    handleStoreModalCancel: handleStoreModalCancel,
    handleStoreModalSubmit: handleStoreModalSubmit,
    setQuery: e => {
      setQuery(e.target.value);
      checkClearBtnListener();
    },
    query: query,
    initiateQuerySearch: initiateSearch,
    handleOnKeyPress: handleOnKeyPress,
    handlePageChange: handlePageChange,
    count: count,
    pageSize: pageSize,
    currentPage: currentPage,
    characterSizeValidationMessage: "Minimum 3 characters required to search.",
    zipCodeValidationMessage: "Enter valid zip code",
    characterLimitPopUp: characterLimitPopUp,
    zipCodeValidation: zipCodeLengthValidation,
    isDataLoading: isDataLoading,
    storeTagBtnDisable: storeTagBtnDisable,
    noStoreMessage: userInfo.userType === 5 ? "No Store is associated with this service provider ".concat(userDetails === null || userDetails === void 0 ? void 0 : (_userDetails$ServiceP = userDetails.ServiceProvider) === null || _userDetails$ServiceP === void 0 ? void 0 : _userDetails$ServiceP.name, ". \n                    You will be notified once it is assigned.") : 'No stores added. Please add a store from "Manage stores" menu.'
  }));
}